// extracted by mini-css-extract-plugin
export var filterIncDec = "_bm-0";
export var leftBorder = "_bm-1";
export var rightBorder = "_bm-2";
export var stringInput = "_bm-3";